<template>
	<div style="min-height: 700px;">
		<div class="sub_top">
			<div class="sub_topul width62">
				<div class="sub_topli">
					<div class="width100">
						<div class="li">
							<img src="../../assets/img/sub_fg.png">
							<span>&nbsp;发稿数</span>
						</div>
						<div class="span">{{CommentData.sumNum}}</div>
					</div>
				</div>
				<div class="sub_topli">
					<div class="width100 border_left_right">
						<div class="li">
							<img src="../../assets/img/sub_yd.png">
							<span>&nbsp;阅读数</span>
						</div>
						<div class="span">{{CommentData.readNum}}</div>
					</div>
				</div>
				<div class="sub_topli">
					<div class="width100">
						<div class="li">
							<img src="../../assets/img/sub_fs.png">
							<span>&nbsp;粉丝数</span>
						</div>
						<div class="span">{{CommentData.fenSiNum}}</div>
					</div>
				</div>
			</div>
			<div class="sub_topul width34">
				<div class="sub_topli2">
					<img src="../../assets/img/ks_fb.png" class="tu_biao">
					<div @click="look_fabu()" style="cursor: pointer;" class="button">快速发布</div>
				</div>
			</div>
		</div>
		<div class="sub_tongzhi">
			<div class="title" style="display: flex;justify-content: space-between;">
				<div>系统通知</div>
				<div @click="look_Morenews()" style="font-size: 16px;color: #999;cursor: pointer;">更多></div>
			</div>
			<div @click="look_news(item.newsId)" class="li" v-for="item in NewList" :key="item.key">
				<div class="li1">【公告】{{item.title}}</div>
				<div class="li2">{{item.createTime}}</div>
			</div>
			<!-- <el-pagination
			  background
			  layout="prev, pager, next"
			  :total="totalCount" style="padding: 40px 0;" prev-text="上一页" next-text="下一页">
			</el-pagination> -->
		</div>
	</div>
</template>
<script>
	import $ from "jquery";
	import axios from "axios";
	export default {
		data() {
			return {
				NewList:[],
				totalCount:0,
				CommentData:{
					fenSiNum:0,
					readNum:0,
					sumNum:0,
				}
			};
		},
		mounted() {
			var self = this
			setTimeout(function(){
				self.getcomontNewsData();
				self.getcomontData();
			},500)
		},
		methods: {
			getcomontNewsData() {
			  this.$http
			    .get("/api/msg/001-sysMsg", {
			      params: {
					pageNo:1,  
			        limit:5,
			      }
			    })
			    .then(res => {
			      if (res.status == 200 && res.data.code == 0) {
			         console.log(res.data)
					 this.NewList=res.data.rows;
					 this.totalCount=res.data.totalCount;
			      }
			    })
			    .catch(err => {
			      console.log(err);
			    });
			},
			getcomontData() {
			  this.$http
			    .get("/api/topic/011--getMyStatisticsList", {
			      params: {
					token: this.$store.state.userInfo.token,
			      }
			    })
			    .then(res => {
					console.log(res)
			      if (res.status == 200 && res.data.code == 0) {
					 if(res.data.rows.length>0){
						this.CommentData=res.data.rows[0];
					 }
			      }
			    })
			    .catch(err => {
			      console.log(err);
			    });
			},
			look_Morenews(){
				//通知页面
				this.$router.push({ path: "tongZhi"});
			},
			look_news(id){
				//无详情
			},
			look_fabu(){
				//图文详情
				this.$router.push({ path: "publishArticle"});
			},
		}
	};
</script>
<style scoped>
	.sub_top {
		width: 100%;
		margin: 23px 0 0 20px;
		display: flex;
		justify-content: space-between;
	}
	.sub_tongzhi{
		width: 100%;
		margin: 44px 0 200px 20px;
		box-shadow:0px 2px 10px 0px rgba(0, 0, 0, 0.16);
	}
	.sub_tongzhi .title{line-height: 56px;height: 56px;text-align: left;font-size: 20px;color: #222;font-weight: bold;padding: 0 20px;width: 100%;border-bottom: 1px solid #f2f2f2;}
	.sub_tongzhi .li{height: 56px;padding: 0 20px;display: flex;align-items: center;justify-content: space-between;cursor: pointer;}
	.sub_tongzhi .li .li1{color: #333;font-size: 16px;font-weight: bold;}
	.sub_tongzhi .li .li2{font-size: 16px;color: #999;}
	.sub_topul{box-shadow:0px 2px 10px 0px rgba(0, 0, 0, 0.16);display: flex;}
	.width100{width: 100%;}
	.width62{width: 62.7%;}
	.width34{width: 34.9%;}
	.border_left_right{width: 100%;border-right: 1px solid #E7E7E7;border-left: 1px solid #E7E7E7;}
	.sub_topli{width: 33.33%;height: 190px;text-align: center;}
	.sub_topli .li{color: #999;font-size: 16px;display: flex;align-items: center;justify-content: center;margin-top: 50px;}
	.sub_topli .li img{height: 17px;width: 14px;margin-top: -3px;}
	.sub_topli .span{margin-top: 25px;font-size: 36px;color: #222;font-weight: bold;}
	.sub_topli2{width: 100%;height: 190px;}
	.sub_topli2 .tu_biao{margin: auto;width: 80px;height: 62px;margin-top: 37px;}
	.sub_topli2 .button{width: 64.8%;height: 40px;background: #2E8043;line-height: 40px;text-align: center;color: #fff;font-size: 14px;margin: auto;margin-top: 20px;}
</style>
